export default "assets/images/icons/close-d392266b.svg";